import type * as React from 'react';

import * as Styled from './input-bar.styles';
const { sizes, variants } = Styled;

export type InputBarSize = keyof typeof sizes;
export type InputBarVariant = keyof typeof variants;

type CommonProps = {
  /** Add custom CSS */
  className?: string;
  /** Pass props to the close button */
  clearButtonProps?: React.ComponentProps<typeof Styled.ClearButton>;
  /** Disable the input or textarea */
  disabled?: boolean;
  /** @callback */
  onClearInput?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** The placeholder attribute of the input or textarea */
  placeholder?: string;
  /** The size on mobile screens or larger */
  size?: InputBarSize;
  /** The size on tablet screens or larger */
  sizeConfined?: InputBarSize;
  /** The size on desktop screens or larger */
  sizeWide?: InputBarSize;
  /** The value attribute of the input or textarea */
  value: string;
  /** The variant of the input-bar */
  variant?: InputBarVariant;
};

type InputProps = CommonProps &
  React.ComponentProps<typeof Styled.Input> & {
    /** leading icon */
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    /** Ref Object */
    innerRef?: React.RefObject<typeof Styled.Input>;
    /** Render a textarea */
    multiline?: never;
    /** @callback */
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };

type TextareaProps = CommonProps &
  React.ComponentProps<typeof Styled.Textarea> & {
    /** Leading icon */
    icon?: never;
    /** Ref Object */
    innerRef?: React.RefObject<typeof Styled.Textarea>;
    /** Render a textarea */
    multiline?: boolean;
    /** @callback */
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  };

export type InputBarProps = InputProps | TextareaProps;
